module.exports = __webpack_public_path__ + "img/level-up-triangle.8c1487fb.png";